import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./Unauthorized.css";

const Unauthorized = () => {
  return (
    <div className="unauth-container">
      <Helmet>
        <title>401 Unauthorized | Attoli</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="unauth-title">401 — Unauthorized</h1>
      <p className="unauth-text">
        You do not have permission to view this page. If you think this is an
        error, please contact us.
      </p>
      <div>
        <Link to="/" className="unauth-btn unauth-link-btn">
          Home
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
